import { render, staticRenderFns } from "./Detail-User.vue?vue&type=template&id=776b93f7&scoped=true"
import script from "./Detail-User.vue?vue&type=script&lang=js"
export * from "./Detail-User.vue?vue&type=script&lang=js"
import style0 from "./Detail-User.vue?vue&type=style&index=0&id=776b93f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776b93f7",
  null
  
)

export default component.exports